import { Component, OnInit } from "@angular/core";
import { Request } from "src/app/parametrage/core/model/request";
import { Router } from "@angular/router";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { CorporateService } from "../../core/service/corporate.service";

@Component({
  selector: "app-cloture",
  templateUrl: "./cloture.component.html",
  styleUrls: ["./cloture.component.scss"],
})
export class ClotureComponent implements OnInit {
  isLoadingResults = true;

  dossiers: Request[];
  formulaire: FormulaireDTO;

  page: number = 0;
  totalElements: number = 0;
  filter: String = "";
  state: String = "";

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _productProgramService: CorporateService,
    private _formulaireService: FormulaireService
  ) {}

  ngOnInit() {
    this.getAll(this.filter, this.state, 0, 5);
  }

  getAll(filter, state, page, size) {
    this.isLoadingResults = true;

    this._productProgramService
      .findAllDossierCloture(filter, state, page, size)
      .subscribe(
        (data) => {
          this.isLoadingResults = false;
          this.dossiers = data.content;
          this.totalElements = data.totalElements;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getAll(this.filter, this.state, page, 5);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.page = 0;
    this.getAll(this.filter, this.state, this.page, 5);
  }

  filterByState(): void {
    this.getAll(this.filter, this.state, 0, 5);
  }

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
